import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const EventInfo = () => {
  useEffect(() => {
    document.title = "Events | Under Open Sky";
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <nav className="p-8 sticky top-0 bg-white/80 backdrop-blur-md z-10">
        <Link to="/" className="text-[10px] uppercase tracking-[0.2em] text-gray-400 hover:text-gray-800 transition-colors">
          ← Zurück zur Übersicht
        </Link>
      </nav>

      <article className="max-w-2xl mx-auto px-6 py-12 pb-40 font-light text-gray-600 leading-relaxed">
        <header className="mb-20">
          <h1 className="text-3xl font-light text-gray-800 mb-4 tracking-tight">Events & Kooperationen</h1>
          <p className="text-gray-400 italic">Konzepte unter freiem Himmel</p>
        </header>
        
        <div className="space-y-10">
          <p>Under Open Sky bietet den Rahmen für Veranstaltungen, die den Wert der Natur und des Augenblicks in den Fokus rücken.</p>
          
          <p>Ob Firmen-Retreats ohne klassischen Seminar-Charakter, private Zusammenkünfte oder handwerkliche Workshops – wir prüfen jedes Vorhaben darauf, ob es in unser Framework passt.</p>
          
          <p>Der Schwerpunkt liegt dabei immer auf der Qualität des Erlebnisses und der Reduktion auf das Wesentliche. Wir unterstützen bei der Planung und Umsetzung an Orten, die Raum zum Atmen lassen.</p>
          
          <div className="pt-20 text-center">
            <p className="mb-4 text-sm uppercase tracking-widest text-gray-400">Interesse?</p>
            <a href="mailto:mike.trepte@underopensky.de" className="text-xl text-gray-800 hover:text-gray-400 transition-colors border-b border-gray-100 pb-2">
              mike.trepte@underopensky.de
            </a>
          </div>
        </div>
      </article>
    </div>
  );
};

export default EventInfo;